import request from ".";

export const newslettersApi = {
  getNewsletters: () =>
    request.post(`MonthlyNewsLetter/getAllMonthlyNewsLetterArabicflags`),
  getNewsletterByUrl: (url: string) =>
    request.post(
      `MonthlyNewsLetter/getMonthlyNewsLetterByUniqUrl?UniqueUrl=${url}`
    ),
};
